module.exports = __webpack_public_path__ + "static/img/1.4bf69f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/1.png
// module id = 07YU
// module chunks = 36